document.addEventListener('DOMContentLoaded', () => {
  const wistiaLaunchButtons = document.querySelectorAll('.js-wistia-launch');
  window._wq = window._wq || [];

  wistiaLaunchButtons.forEach(button => {
    button.addEventListener('click', (e) => {
      e.stopPropagation();

      // Find the closest .js-wistia-launch element (could be e.target or a parent)
      const wistiaButton = e.target.closest('.js-wistia-launch');
      
      const wistiaId = wistiaButton ? wistiaButton.getAttribute('data-wistiaId') : null;
      const targetId = wistiaButton ? wistiaButton.getAttribute('data-target') : null;
      
      // Add debugging info
      if (!wistiaId || !targetId) {
        console.warn('Wistia button missing required attributes:', {
          clickedElement: e.target,
          wistiaButton: wistiaButton,
          wistiaId: wistiaId,
          targetId: targetId,
          buttonClasses: wistiaButton ? wistiaButton.className : 'no button found'
        });
        return;
      }
      
      let wistiaData = document.getElementById(`wistiaData-${wistiaId}`);

      const handleReady = (video) => {
        video.popover.show();
        video.play();
      };

      if (wistiaData) {
        _wq.push({ id: wistiaId, onReady: handleReady });
        return;
      }

      if (!document.getElementById('wistiaLibrary')) {
        const libScript = document.createElement('script');
        libScript.src = 'https://fast.wistia.com/assets/external/E-v1.js';
        libScript.id = 'wistiaLibrary';
        libScript.async = true;
        document.head.appendChild(libScript);
      }

      const containerHTML = `
        <div class="wistia_responsive_padding" style="padding:56.25% 0 0 0;position:relative;">
          <div class="wistia_responsive_wrapper" style="height:100%;left:0;position:absolute;top:0;width:100%;">
            <span class="wistia_embed wistia_async_${wistiaId} popover=true popoverAnimateThumbnail=true videoFoam=true"
              style="display:inline-block;height:100%;position:relative;width:100%">&nbsp;</span>
          </div>
        </div>`;

      const targetNode = document.getElementById(targetId);
      if (!targetNode) {
        console.warn(`Wistia target container not found: ${targetId}`);
        return;
      }
      targetNode.innerHTML = containerHTML;

      wistiaData = document.createElement('script');
      wistiaData.src = `https://fast.wistia.com/embed/medias/${wistiaId}.jsonp`;
      wistiaData.id = `wistiaData-${wistiaId}`;
      wistiaData.async = true;
      targetNode.appendChild(wistiaData);

      _wq.push({ id: wistiaId, onReady: handleReady });
    }, { capture: true });
  });

  // Get cookie by name
  function getCookie(name) {
    return document.cookie
      .split('; ')
      .find(row => row.startsWith(name + '='))
      ?.split('=')[1] || '';
  }

  // Check if Wistia block exists
  if (document.querySelector('.block-wistia-embed')) {
    console.log('wistia-exists');

    const mktoPromise = new Promise((resolve) => {
      setTimeout(() => {
        const mktoCookie = getCookie('_mkto_trk');
        let email = '';

        if (mktoCookie) {
          console.log('wistia mkto track', mktoCookie);

          fetch(`/wp-admin/admin-ajax.php?action=marketo_prefill&_mkto_trk=${encodeURIComponent(mktoCookie)}`)
            .then(res => res.text())
            .then(text => {
              const data = JSON.parse(text);
              if (data.success && data.result?.length) {
                email = data.result[0].email;
              }
              resolve(email);
            })
            .catch(() => resolve(email));
        } else {
          resolve(email);
        }
      }, 500);
    });

    mktoPromise.then(email => {
      console.log('wistia-testing');

      const onReadyHandler = (video) => {
        video.bind('play', () => {
          const allVideos = Wistia.api.all();
          allVideos.forEach(v => {
            if (v.hashedId() !== video.hashedId()) v.pause();
          });
        });

        if (email) {
          video.bind('percentwatchedchanged', (percent, lastPercent) => {
            if (percent >= 0.01 && lastPercent < 0.01) {
              console.log('The viewer has watched 1% of the video');

              window.Bizible = window.Bizible || {
                _queue: [],
                Push(o, p) {
                  this._queue.push({ type: o, data: p });
                }
              };

              Bizible.Push('User', { eMail: email });
            }
          });
        }
      };

      _wq.push({ id: '_all', onReady: onReadyHandler });
    });
  }
});